import { render, staticRenderFns } from "./CampanasCupones.vue?vue&type=template&id=cbeff944"
import script from "./CampanasCupones.vue?vue&type=script&lang=js"
export * from "./CampanasCupones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports